export default "/assets/images/2022aug/online_release.svg"